import React from "react";
import themePropTypes from "../theme-prop-types";

const ValidationMessage = ({
  isInvalid,
  fieldName,
  isUnifiedRegistration,
  children
}) => (
  <div
    id={fieldName ? `inline-error-${fieldName}` : null}
    className='message-container'
    aria-live={isUnifiedRegistration ? "off" : "polite"}
  >
    {isInvalid &&
      (Array.isArray(children) ? (
        children.map(error => (
          <div className='inline-error-message-web-sdk' key={error}>
            {error}
          </div>
        ))
      ) : (
        <div className='inline-error-message-web-sdk'>{children}</div>
      ))}
  </div>
);

ValidationMessage.propTypes = themePropTypes.validationMessage;

export default ValidationMessage;
